"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomId = exports.randomClientId = void 0;
const availableChars = '23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz'; // https://github.com/meteor/meteor/blob/master/packages/random/random.js#L88
const length = 17;
/** @deprecated Use randomId instead */
function randomClientId() {
    return randomId();
}
exports.randomClientId = randomClientId;
// Note, not cryptograhically or database secure, just imitating the output of Meteor's Random.id()
// generate a 17 character random string
// TODO: prevent collisions
function randomId() {
    const randomArray = new Array(length)
        .fill(0)
        .map(() => availableChars[Math.floor(Math.random() * availableChars.length)]);
    return randomArray.join('');
}
exports.randomId = randomId;
//# sourceMappingURL=random-id.js.map